export default __webpack_public_path__ + "static/media/bg.ee316e0d.png";